import { createContext, useContext } from "react";
import type { SelectedNodeIdContextType } from "@app/services/aiFlow.types";

export const SelectedNodeIdContext = createContext<
  SelectedNodeIdContextType | undefined
>(undefined);

export const useSelectedNodeId = () => {
  const context = useContext(SelectedNodeIdContext);
  if (!context) {
    throw new Error(
      "useSelectedNodeId must be used within a SelectedNodeIdProvider"
    );
  }
  return context;
};
